import { render, staticRenderFns } from "./clashofwars.vue?vue&type=template&id=93522504&scoped=true"
import script from "./clashofwars.vue?vue&type=script&lang=js"
export * from "./clashofwars.vue?vue&type=script&lang=js"
import style0 from "./clashofwars.vue?vue&type=style&index=0&id=93522504&prod&scoped=true&lang=css"
import style1 from "./clashofwars.vue?vue&type=style&index=1&id=93522504&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93522504",
  null
  
)

export default component.exports